module.exports = __webpack_public_path__ + "00fd3ab54be5698edaa4cf5c4c9b4e90.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/pinterest_2023_chart.png
// module id = 1718
// module chunks = 0